import randomcolor from 'randomcolor'; // tslint:disable-line

const colors = [
    "#e6194B",
    "#3cb44b",
    "#ffe119",
    "#4363d8",
    "#f58231",
    "#911eb4",
    "#42d4f4",
    "#bfef45",
    "#469990",
    "#e6beff",
    "#9A6324",
    "#fffac8",
    "#800000",
    "#aaffc3",
    "#808000",
    "#ffd8b1",
    "#000075",
    "#a9a9a9",
]

export function getRandomColor() {
    return randomcolor({
        luminosity: 'dark',
    });
}

export function getColor(index: number) {
    const trueIndex = index % colors.length;
    return colors[trueIndex];
}





// WEBPACK FOOTER //
// ./src/views/Utils.tsx